<script>
import { isUndefined } from "lodash-es";

import { CLASS_NAME_COMPONENT_BUTTON_GROUP } from "./common";

export default {
  name: "TgSelectorButtonGroup",
  props: {
    selected: {
      type: [Number, String, Object],
      default: 0
    },
    items: {
      type: Array,
      required: true
    }
  },
  emits: ["clickSelected", "input"],
  data() {
    return {
      selectedIndex: undefined,
      tabbableIndex: undefined
    };
  },
  computed: {
    classes() {
      return [CLASS_NAME_COMPONENT_BUTTON_GROUP];
    }
  },
  watch: {
    selected: {
      handler(newValue) {
        this.tabbableIndex = 0;

        if (newValue === "") {
          this.selectedIndex = undefined;
          return;
        }

        const selectedIndex = this.items.indexOf(newValue);
        if (isUndefined(selectedIndex)) {
          return;
        }

        this.selectedIndex = selectedIndex;
        this.tabbableIndex = selectedIndex;
      },
      immediate: true
    }
  },
  methods: {
    handleBlur() {
      if (isUndefined(this.selectedIndex)) {
        this.tabbableIndex = 0;

        return;
      }

      this.tabbableIndex = this.selectedIndex;
    },

    handleSelect(activeIndex) {
      this.tabbableIndex = activeIndex;

      if (this.selectedIndex === activeIndex) {
        this.$emit("clickSelected");

        return;
      }

      this.selectedIndex = activeIndex;
      this.$emit("input", {
        index: activeIndex,
        item: this.items[activeIndex]
      });
    },

    handleFocusNext(activeIndex) {
      this.tabbableIndex = activeIndex + 1 === this.items.length ? 0 : activeIndex + 1;
      this.focusTabbableIndexElement();
    },

    handleFocusPrev(activeIndex) {
      this.tabbableIndex = activeIndex === 0 ? this.items.length - 1 : activeIndex - 1;
      this.focusTabbableIndexElement();
    },

    focusTabbableIndexElement() {
      if (document?.activeElement?.parentElement.children?.[this.tabbableIndex]) {
        document.activeElement.parentElement.children[this.tabbableIndex].focus?.();
      }
    }
  }
};
</script>

<template>
  <div role="radiogroup" :class="classes">
    <slot
      :handle-blur="handleBlur"
      :handle-select="handleSelect"
      :handle-focus-next="handleFocusNext"
      :handle-focus-prev="handleFocusPrev"
      :state="{ selectedIndex, tabbableIndex }"
    />
  </div>
</template>
